import moment from 'moment';

export const transfer2LocalMinTime = (date: Date | string) => {
  return moment(date).format('MM-DD HH:mm');
};

export const transfer2LocalTime = (date: Date | string) => {
  return moment(date).format('YYYY-MM-DD HH:mm:ss');
};

export const transfer2LocalDate = (date: Date | string) => {
  return moment(date).format('YYYY-MM-DD');
};

/**
 * 距今多久 —— 用來回答「這顆錢包開立多久了」這種問題。
 *
 * 刻意只給一個粗粒度單位(3 天 / 5 個月),不做「3 天 4 小時 12 分」。
 * 看這欄的人要的是「這顆是新的還是舊的」,精確到分鐘反而難掃。
 * 未來時間(時鐘偏移)夾到 0,不要出現「-2 分鐘」。
 */
export const transfer2Elapsed = (date: Date | string) => {
  const d = moment(date);
  if (!date || !d.isValid()) return '—';
  const now = moment();
  const minutes = Math.max(now.diff(d, 'minutes'), 0);
  if (minutes < 60) return `${minutes} 分鐘`;
  const hours = now.diff(d, 'hours');
  if (hours < 24) return `${hours} 小時`;
  const days = now.diff(d, 'days');
  if (days < 30) return `${days} 天`;
  const months = now.diff(d, 'months');
  if (months < 12) return `${months} 個月`;
  return `${(months / 12).toFixed(1)} 年`;
};
